// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/productivity-ot-data/ot-machine-downtimes",
  Create: "/pyr/productivity-ot-data/ot-machine-downtimes",
  Sync: "/pyr/productivity-ot-data/ot-machine-downtimes/sync",
};
